<template>
  <div>
    <select
      id="language-select"
      @change="changeLanguage"
      v-model="selectedLanguage"
    >
      <option value="en">English</option>
      <option value="es">Español</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'LangSelector',
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage
      localStorage.setItem('preferredLanguage', this.selectedLanguage)
    },
    detectBrowserLanguage() {
      const browserLanguage = navigator.language || navigator.languages[0] // Idioma del navegador
      const supportedLanguages = ['en', 'es']
      const defaultLanguage = 'en'
      return supportedLanguages.includes(browserLanguage.substring(0, 2))
        ? browserLanguage.substring(0, 2)
        : defaultLanguage
    },
  },
  created() {
    const savedLanguage = localStorage.getItem('preferredLanguage')
    if (savedLanguage) {
      this.$i18n.locale = savedLanguage
      this.selectedLanguage = savedLanguage
    } else {
      const browserLanguage = this.detectBrowserLanguage()
      this.$i18n.locale = browserLanguage
      this.selectedLanguage = browserLanguage
    }
  },
}
</script>

<style scoped>
#language-select {
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  color: #ffffff;
}

#language-select option {
  color: #222222;
}
</style>
